// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"InfoDownloads_itemContainer__1U5xb","title":"InfoDownloads_title__3izsc","button":"InfoDownloads_button__jlpeQ"};